<script setup lang="ts">
import {type PropType, ref} from 'vue';
import {ProductDto} from '@/api/enterprise-gateway-api.proxy.ts';
import {useFormatting} from '@/composables/currency-format.ts';
import {Column, DataTable, Button, Dialog} from 'primevue';
import {isEmpty} from 'lodash-es';

const props = defineProps({
  products: { type: Array as PropType<ProductDto[]>, default: () => ({})},
});

const {formatCurrency, formatDate} = useFormatting();

const selectedProduct = ref<ProductDto | null>(null);
const selectedProductModalVisible = ref(false);

const getProductId = (product: ProductDto | null): string => {
  if (!product) {
    return '';
  }
  if (!product.variantCode) {
    return product.productId || '';
  }
  return `${product.productId} - ${product.variantCode}`;
}

const hasMetaData = (product: ProductDto | null): boolean => {
  return !isEmpty(product?.metaData);
}

</script>

<template>
  <aeg-datatable :value="products">
    <Column header="Product Id" :field="(product) => getProductId(product)" />
    <Column header="Prijs excl. BTW" :field="(product) => formatCurrency(product.amountExclVat)" body-style="text-align: right;" />
    <Column header="BTW" :field="(product) => product.vatRate + ' %'" />
    <Column header="Referentie Id" field="salesLineReferenceId" />
    <Column header="Referentie" field="description" />

    <Column>
      <template #body="slotProps">
        <Button
            v-if="hasMetaData(slotProps.data)"
            icon='pi pi-code'
            rounded outlined
            @click="selectedProduct = slotProps.data; selectedProductModalVisible = true;"
        />
      </template>
    </Column>
  </aeg-datatable>

  <Dialog v-model:visible="selectedProductModalVisible" modal :header="'metadata: ' + getProductId(selectedProduct)" @close="() => { selectedProduct = null; console.log('sdfds') }">
    <pre>{{ JSON.stringify(selectedProduct?.metaData, null, 2) }}</pre>
  </Dialog>
</template>

<style scoped lang="scss">
</style>
